import { jsx as _jsx } from "react/jsx-runtime";
import get from 'lodash/fp/get';
import { DateTime } from 'luxon';
var defaultProps = {
    dateTimeFormat: 'dd. MM. yyyy HH:mm',
};
export var DateTimeCell = function (_a) {
    var _b;
    var rowData = _a.rowData, column = _a.column;
    var value = get(column.name, rowData);
    var dateTimeFormat = ((_b = column === null || column === void 0 ? void 0 : column.passProps) !== null && _b !== void 0 ? _b : defaultProps).dateTimeFormat;
    return value ? _jsx("span", { children: DateTime.fromISO(value).toFormat(dateTimeFormat) }) : null;
};
